import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-border border-t-neutral-800" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Phase 27.5 — Email verification is mandatory. Users who somehow
  // hold a token but never verified (e.g. legacy accounts or a
  // backend regression) are forced through /verify-email before they
  // can use any protected page.
  if (user.email_verified === false) {
    return (
      <Navigate
        to={`/verify-email?email=${encodeURIComponent(user.email || '')}`}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
